import { Flex, Text } from "@chakra-ui/react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthentication } from "../wrappers/UseAuthentication";
import LoadingBlock from "./shared/LoadingBlock";
import { neutral, type } from "../theme/tokens";

// Shown for the fraction of a second it takes to swap a stored refresh token
// for a live session. Without this gate the router resolves `isAuthenticated:
// false` on the very first render and redirects to /signin before the token
// has even been sent — which is what made "Remember this device" look broken.
const RestoringSession = () => (
  <Flex direction="column" align="center" justify="center" minH="100vh" bg={neutral[50]} gap={1}>
    <LoadingBlock label="Restoring your session…" minH="0px" />
    <Text fontSize={type.size.small} color={neutral[400]}>
      SpearBI
    </Text>
  </Flex>
);

const RequireAuth = () => {
  const { isAuthenticated, restoring } = useAuthentication();
  const location = useLocation();

  if (restoring) return <RestoringSession />;

  if (!isAuthenticated) {
    const target = location.pathname.replace(/^\//, "");
    const search = target ? `?redirect=${encodeURIComponent(target)}` : "";
    return <Navigate to={`/signin${search}`} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
